var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8.32639,
    fill: "#ECF0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3337 27.5V25.8333C28.3337 24.2801 27.2713 22.9751 25.8337 22.605M22.917 12.7423C24.1386 13.2368 25.0003 14.4344 25.0003 15.8333C25.0003 17.2322 24.1386 18.4299 22.917 18.9244M24.167 27.5C24.167 25.9469 24.167 25.1703 23.9133 24.5577C23.5749 23.741 22.926 23.092 22.1093 22.7537C21.4967 22.5 20.7201 22.5 19.167 22.5H16.667C15.1139 22.5 14.3373 22.5 13.7247 22.7537C12.908 23.092 12.259 23.741 11.9207 24.5577C11.667 25.1703 11.667 25.9469 11.667 27.5M21.2503 15.8333C21.2503 17.6743 19.7579 19.1667 17.917 19.1667C16.076 19.1667 14.5837 17.6743 14.5837 15.8333C14.5837 13.9924 16.076 12.5 17.917 12.5C19.7579 12.5 21.2503 13.9924 21.2503 15.8333Z",
    stroke: "#5D82DB",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.8b3c6ca53ff2b4b910fb04c50ccba47b.svg";
export { ForwardRef as ReactComponent };